import { render, staticRenderFns } from "./WorkModule.vue?vue&type=template&id=78150935&"
import script from "./WorkModule.vue?vue&type=script&lang=ts&"
export * from "./WorkModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports